//Brand site domains used for myAccount verification flow
export enum verificationDomains {
	buickStageAkamai = 'https://www-buick-com.stage.acp.gm.com',
	buickRcSitAkamai = 'https://www-buick-com.rcsit.acp.gm.com',
	buickSitAkamai = 'https://www-buick-com.sit.acp.gm.com',
	buickCanadaStageAkamai = 'https://www-buick-ca.stage.acp.gm.com',
	buickCanadaRcSitAkamai = 'https://www-buick-ca.rcsit.acp.gm.com',
	buickCanadaSitAkamai = 'https://www-buick-ca.sit.acp.gm.com',
	cadillacStageAkamai = 'https://www-cadillac-com.stage.acp.gm.com',
	cadillacRcSitAkamai = 'https://www-cadillac-com.rcsit.acp.gm.com',
	cadillacSitAkamai = 'https://www-cadillac-com.sit.acp.gm.com',
	cadillacCanadaStageAkamai = 'https://www-cadillaccanada-ca.stage.acp.gm.com',
	cadillacCanadaRcSitAkamai = 'https://www-cadillaccanada-ca.rcsit.acp.gm.com',
	cadillacCanadaSitAkamai = 'https://www-cadillaccanada-ca.sit.acp.gm.com',
	chevyStageAkamai = 'https://www-chevrolet-com.stage.acp.gm.com',
	chevyRcSitAkamai = 'https://www-chevrolet-com.rcsit.acp.gm.com',
	chevySitAkamai = 'https://www-chevrolet-com.sit.acp.gm.com',
	chevyCanadaStageAkamai = 'https://www-chevrolet-ca.stage.acp.gm.com',
	chevyCanadaRcSitAkamai = 'https://www-chevrolet-ca.rcsit.acp.gm.com',
	chevyCanadaSitAkamai = 'https://www-chevrolet-ca.sit.acp.gm.com',
	crossBrandsStageAkamai = 'https://experience-gm-com.stage.acp.gm.com',
	crossBrandsRcSitAkamai = 'https://experience-gm-com.rcsit.acp.gm.com',
	crossBrandsSitAkamai = 'https://experience-gm-com.sit.acp.gm.com',
	crossBrandsCanadaStageAkamai = 'https://experience-gm-ca.stage.acp.gm.com',
	crossBrandsCanadaRcSitAkamai = 'https://www-experience-gm-ca.rcsit.acp.gm.com',
	crossBrandsCanadaSitAkamai = 'https://experience-gm-ca.sit.acp.gm.com',
	gmcStageAkamai = 'https://www-gmc-com.stage.acp.gm.com',
	gmcRcSitAkamai = 'https://www-gmc-com.rcsit.acp.gm.com',
	gmcSitAkamai = 'https://www-gmc-com.sit.acp.gm.com',
	gmcCanadaStageAkamai = 'https://www-gmccanada-ca.stage.acp.gm.com',
	gmcCanadaRcSitAkamai = 'https://www-gmccanada-ca.rcsit.acp.gm.com',
	gmcCanadaSitAkamai = 'https://www-gmccanada-ca.sit.acp.gm.com',
	cadillacJapanStageAkamai = 'https://www-cadillacjapan-com.stage.acp.gm.com ',
	cadillacJapanRcSitAkamai = 'https://www-cadillacjapan-com.rcsit.acp.gm.com',
	cadillacJapanSitAkamai = 'https://www-cadillacjapan-com.sit.acp.gm.com',
	chevyJapanStageAkamai = 'https://www-chevroletjapan-com.stage.acp.gm.com',
	chevyJapanRcSitAkamai = 'https://www-chevroletjapan-com.rcsit.acp.gm.com',
	chevyJapanSitAkamai = 'https://www-chevroletjapan-com.sit.acp.gm.com',
	chevyMexicoStageAkamai = 'https://www-chevrolet-com-mx.stage.acp.gm.com',
	chevyMexicoRcSitAkamai = 'https://www-chevrolet-com-mx.rcsit.acp.gm.com',
	chevyMexicoSitAkamai = 'https://www-chevrolet-com-mx.sit.acp.gm.com',
	gmcMexicoStageAkamai = 'https://www-gmc-com-mx.stage.acp.gm.com',
	gmcMexicoRcSitAkamai = 'https://www-gmc-com-mx.rcsit.acp.gm.com',
	gmcMexicoSitAkamai = 'https://www-gmc-com-mx.sit.acp.gm.com',
	buickMexicoStageAkamai = 'https://www-buick-com-mx.stage.acp.gm.com',
	buickMexicoRcSitAkamai = 'https://www-buick-com-mx.rcsit.acp.gm.com',
	buickMexicoSitAkamai = 'https://www-buick-com-mx.sit.acp.gm.com',
	cadillacMexicoStageAkamai = 'https://www-cadillac-com-mx.stage.acp.gm.com',
	cadillacMexicoRcSitAkamai = 'https://www-cadillac-com-mx.rcsit.acp.gm.com',
	cadillacMexicoSitAkamai = 'https://www-cadillac-com-mx.sit.acp.gm.com',
	onstarMexicoStageAkamai = 'https://www-onstar-com-mx.stage.acp.gm.com',
	onstarMexicoRcSitAkamai = 'https://www-onstar-com-mx.rcsit.acp.gm.com',
	onstarMexicoSitAkamai = 'https://www-onstar-com-mx.sit.acp.gm.com',
}
